<div *ngIf="device" class="progress-container-outer mc-card-memory-options">
  <ul class="progress-container list-unstyled" [ngClass]="device.memoryStatus">
    <li>
      <span class="left property-title">{{ 'label_Memory' | xsI18n }}</span>
      <span class="right property-value">{{ device.totalMemory }}</span>
    </li>
    <li class="graph">
      <mat-progress-bar
        [color]="device.usedMemoryPercentage > 80 ? 'warn' : ''"
        [value]="device.usedMemoryPercentage"
      ></mat-progress-bar>
    </li>
    <li class="property-keys" [hidden]="!device.memoryLabel">
      <span class="left property-key">{{ 'label_Used' | xsI18n }}</span>
      <span class="right property-key">{{ 'label_Available' | xsI18n }}</span>
    </li>
    <li class="property-values" [hidden]="!device.memoryLabel">
      <span class="left property-value">{{ device.usedMemory }} </span>
      <span class="right property-value">{{ device.availableMemory }} </span>
    </li>
  </ul>
</div>
